<!-- Quick stats boxes -->
<div class="row">
    <div class="col-lg-3">

        <!-- Members online -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <!-- <span class="heading-text badge bg-teal-800">+53,6%</span> -->
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{stats?.total_users|number:'1.0-2'}}</h3>
                <strong>Total Users</strong>
                <div class="text-size-small">{{stats?.active_users|number:'1.0-2'}} active users</div>
            </div>

            <div class="container-fluid">
                <div id="members-online"></div>
            </div>
        </div>
        <!-- /members online -->

    </div>

    <div class="col-lg-3">

        <!-- Current server load -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{stats?.total_sales.count|number:'1.0-2'}}</h3>
                <strong>Total Sales</strong>
                <div class=" text-size-small">Pending sales - {{stats?.pending_sales.count|number:'1.0-2'}} -
                    {{stats?.pending_sales.value|number:'1.2-2'}} ETB </div>
            </div>

            <div id="server-load"></div>
        </div>
        <!-- /current server load -->

    </div>

    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{stats?.awards_granted.count|number:'1.0-2'}}</h3>
                <strong>Awards Granted</strong>
                <div class="text-size-small">Estimated value - {{stats?.awards_granted.value|number:'1.2-2'}} ETB</div>
            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>


    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-700">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h3 class="no-margin">{{stats?.awards_pending.count|number:'1.0-2'}}</h3>
                <strong>Awards Pending</strong>
                <div class="text-size-small">Estimated value - {{stats?.awards_granted.value|number:'1.2-2'}} ETB</div>
            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>

</div>
<!-- /quick stats boxes -->

<div class="row">

    <div class="col-md-8">

        <!-- Marketing campaigns -->
        <div class="panel panel-flat">
            <div class="panel-heading">
                <h6 class="panel-title">Statistics</h6>
                <div class="heading-elements">
                    <!-- <span class="label bg-success heading-text">28 active</span> -->
                    <ul class="icons-list">
                        <li class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                <!--  <i class="icon-menu7"></i> -->
                                <span class="caret"></span>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                    <a href="#">
                                        <i class="icon-sync"></i> Update data</a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i class="icon-list-unordered"></i> Detailed log</a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i class="icon-pie5"></i> Statistics</a>
                                </li>
                                <li class="divider"></li>
                                <li>
                                    <a href="#">
                                        <i class="icon-cross3"></i> Clear list</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

            <fusioncharts [chartConfig]="chartConfig" [dataSource]="dataSource">
            </fusioncharts>

        </div>
        <!-- /marketing campaigns -->


    </div>

    <div class="col-md-4">


        <!-- My messages -->
        <div class="panel panel-flat">
            <!-- <div class="panel-heading">
                <h6 class="panel-title">Summary Report</h6>
                <div class="heading-elements">
                     <span class="heading-text">
                        <i class="icon-history text-warning position-left"></i> Jul 7, 10:30</span>
                </div>
            </div> -->

            <!-- Numbers -->
            <!--  <div class="container-fluid">
                <div class="row text-center">
                    <div class="col-md-4">
                        <div class="content-group">
                            <h6 class="text-semibold no-margin">
                                <i class="icon-clipboard3 position-left text-slate"></i> 2,345
                            </h6>
                            <span class="text-muted text-size-small">This week</span>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="content-group">
                            <h6 class="text-semibold no-margin">
                                <i class="icon-calendar3 position-left text-slate"></i> 3,568
                            </h6>
                            <span class="text-muted text-size-small">This month</span>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="content-group">
                            <h6 class="text-semibold no-margin">
                                <i class="icon-comments position-left text-slate"></i> 32,693
                            </h6>
                            <span class="text-muted text-size-small">All time</span>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- /numbers -->

            <!-- Tabs -->
            <ul
                class="nav nav-lg nav-tabs nav-justified no-margin no-border-radius bg-slate-800 border-top border-top-white-300">
                <li class="active">
                    <a href="#messages-tue" class="text-size-small text-uppercase" data-toggle="tab">
                        Recent Transactions
                    </a>
                </li>

                <li>
                    <a href="#messages-mon" class="text-size-small text-uppercase" data-toggle="tab">
                        Recent Awards
                    </a>
                </li>

                <li>
                    <a href="#messages-fri" class="text-size-small text-uppercase" data-toggle="tab">
                        Recent Sales
                    </a>
                </li>
            </ul>
            <!-- /tabs -->


            <!-- Tabs content -->
            <div class="tab-content">
                <div class="tab-pane active fade in has-padding" id="messages-tue">
                    <ul class="media-list">
                        <li class="media" *ngFor="let trxn of stats?.recent_transactions">
                            <div class="media-left">
                                <img *ngIf="!trxn?.user?.data?.avatar" src="assets/img/userm.png" width="40" height="40"
                                    class="img-circle img-md" alt="">
                                <img *ngIf="trxn?.user?.data?.avatar"
                                    [src]="baseUrl+'assets/'+trxn.user.data.avatar+'/render'" width="40" height="40"
                                    class="img-circle img-md" alt="">
                            </div>

                            <div class="media-body">
                                <a [routerLink]="['/transactions']">
                                    {{trxn?.user?.data?.username}} - {{trxn.ekub.ekub_id}} -
                                    {{trxn.amount|number:'1.2-2'}} ETB
                                    <span class="media-annotation pull-right">{{trxn.transaction_date|date:long}}</span>
                                </a>
                                <span class="display-block text-muted">{{trxn.status}}</span>
                            </div>
                        </li>
                        <li *ngIf="stats?.recent_transactions?.length <=0" class="media">
                            <div class="media-left">
                                <i class="icon-info22"></i>
                            </div>

                            <div class="media-body">
                                <span class="display-block text-muted">No Transactions are recorded yet!</span>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="tab-pane fade has-padding" id="messages-mon">
                    <ul class="media-list">
                        <li class="media" *ngFor="let award of stats?.recent_awards">
                            <div class="media-left">
                                <img src="assets/img/placeholder.jpg" class="img-circle img-sm" alt="">
                            </div>

                            <div class="media-body">
                                <a [routerLink]="['/awards']">
                                    {{award.ekub.ekub_id}}
                                    <span class="media-annotation pull-right">{{award.draw_date|date:short}}</span>
                                </a>

                                <span class="display-block text-muted">{{award.status}}</span>
                            </div>
                        </li>
                        <li *ngIf="stats?.recent_awards?.length <=0" class="media">
                            <div class="media-left">
                                <i class="icon-info22"></i>
                            </div>

                            <div class="media-body">
                                <span class="display-block text-muted">No Awards given yet!</span>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="tab-pane fade has-padding" id="messages-fri">
                    <ul class="media-list">
                        <li class="media" *ngFor="let sale of stats?.recent_sales">
                            <div class="media-left">
                                <img *ngIf="!sale?.seller?.data?.avatar" src="assets/img/userm.png" width="40"
                                    height="40" class="img-circle img-md" alt="">
                                <img *ngIf="sale?.seller?.data?.avatar"
                                    [src]="baseUrl+'assets/'+sale.seller.data.avatar+'/render'" width="40" height="40"
                                    class="img-circle img-md" alt="">
                            </div>

                            <div class="media-body">
                                <a [routerLink]="['/sales']">
                                    {{sale.seller.data.username}}
                                    <span class="media-annotation pull-right">{{sale.deadline|date:long}} </span>
                                </a><br>
                                <span class="text-muted">
                                    {{sale.min_offer|number:'1.2-2'}} ETB
                                    <span class="media-annotation pull-right">{{sale.status}}</span>
                                </span>
                            </div>

                            <div class="media-right">
                                <img *ngIf="!sale?.buyer?.data?.avatar" src="assets/img/userm.png" width="40"
                                    height="40" class="img-circle img-md" alt="">
                                <img *ngIf="sale?.buyer?.data?.avatar"
                                    [src]="baseUrl+'assets/'+sale.buyer.data.avatar+'/render'" width="40" height="40"
                                    class="img-circle img-md" alt="">
                            </div>
                        </li>
                        <li *ngIf="stats?.recent_sales?.length <=0" class="media">
                            <div class="media-left">
                                <i class="icon-info22"></i>
                            </div>

                            <div class="media-body">
                                <span class="display-block text-muted">No Sales recorded yet!</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- /tabs content -->

        </div>
        <!-- /my messages -->

    </div>
</div>